import { render } from "./pb.vue?vue&type=template&id=35d0a97c"
import script from "./pb.vue?vue&type=script&lang=js"
export * from "./pb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__